import React from 'react';
import { SampleDocument } from '../../../../utils/PDFgenerator/samplePDF';
import { PDFContainer } from '../../../shared/PDFContainer';

const PDFPreview = () => {
    return (
        <PDFContainer>
            <SampleDocument />
        </PDFContainer>
    );
};

export default PDFPreview;
